import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers/display-toast';

import { createSupportRequest } from '../api/support.api';
import { useApiError } from './use-api-error';

export const useCreateSupportRequest = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('common');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (message: string) => createSupportRequest(message),
    onSuccess: () => {
      displayToastSuccess(t('support.toasts.success'));
      onSuccess?.();
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'support.toasts.error');
    },
  });
};
